import { Dropdown, Menu } from 'antd';
import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Table, TableBody } from 'semantic-ui-react';

import customFetch from '../../../utils/customFetch';
import iframe from '../../dashboard-routes/Iframe/iframeData';
import { TableEmptyMessage, TableFooterPagination, TableHeader } from '../../shared/table';
import * as api from '../../../stores/api';
import LMQCriteriasStore from './LMQCriteriasStore';
import router from '../../../stores/router';
import dashboardStore from '@stores/dashboard';

const columns = [
  { title: '' },
  { title: 'ID', sortKey: 'Id' },
  { title: 'Name', sortKey: 'Name' },
  { title: 'Status', sortKey: 'IsActive' },
  { title: 'Description' },
];

@observer
class LMQCriteriasTable extends React.Component {
  openModal = options => {
    return LMQCriteriasStore.toggleModal(true, options);
  };

  handleDelete = id => async () => {
    LMQCriteriasStore.setFieldsValue({ loading: true });

    try {
      await customFetch('/LMQ/DeleteRecord', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ id }),
      });
      await LMQCriteriasStore.refetch({}, true);
    } finally {
      LMQCriteriasStore.setFieldsValue({ loading: false });
    }
  };

  handleEditItemStatus = (id, record) => async () => {
    LMQCriteriasStore.setFieldsValue({ loading: true });

    try {
      await customFetch('/LMQ/SaveData', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ id, IsActive: !record.IsActive, Name: record.Name, Description: record.Description }),
      });
      await LMQCriteriasStore.refetch({}, true);
    } finally {
      LMQCriteriasStore.setFieldsValue({ loading: false });
    }
  };

  onOpenCaseDetail = (record, id) => () => {
    localStorage.setItem('LMQCriterias', record.Name);
    router.history.push({
      pathname: '/view/add-edit-lmq',
      state: {
        record,
      },
      search: `?id=${id}`,
    });
  };

  renderTableBody = (data, colSpan) => {
    if (!data || !data.itemList.length) {
      return <TableEmptyMessage colSpan={colSpan} />;
    }

    return data.itemList.map(({ Id, ...record }) => (
      <Table.Row key={Id} negative={!record.IsActive}>
        {api.isAdmin() && <Table.Cell className="Cell-actions">{this.renderTableActions(Id, record)}</Table.Cell>}
        <Table.Cell>{Id}</Table.Cell>
        <Table.Cell
          selectable
          className={cx({ 'Cell-nowrap Cell-link': record.IsActive })}
          onClick={this.onOpenCaseDetail(record, Id)}
        >
          <Link
            onClick={this.onOpenCaseDetail(record, Id)}
            to={{
              pathname: '/view/add-edit-lmq',
              state: {
                record,
              },
              search: `?id=${Id}`,
            }}
          >
            {record.Name}
          </Link>
        </Table.Cell>
        <Table.Cell>
          <p className={cx({ 'text-danger': !record.IsActive })}>{record.IsActive ? `Active` : `Inactive`}</p>
        </Table.Cell>
        <Table.Cell>{record.Description}</Table.Cell>
      </Table.Row>
    ));
  };

  renderTableActions = (id, record) => (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu>
          {record.IsActive === true ? (
            <Menu.Item onClick={this.onOpenCaseDetail(record, id)}>Edit</Menu.Item>
          ) : (
            <div></div>
          )}
          {!record.IsActive && (
            <Menu.Item
              onClick={this.openModal({
                modalType: 'confirm',
                message: 'Do you want to enable this item?',
                onOk: this.handleEditItemStatus(id, record),
              })}
            >
              Enable
            </Menu.Item>
          )}
          {record.IsActive && (
            <Menu.Item
              onClick={this.openModal({
                modalType: 'confirm',
                message: 'Do you want to disable this item?',
                onOk: this.handleEditItemStatus(id, record),
              })}
            >
              Disable
            </Menu.Item>
          )}
          <Menu.Item
            onClick={this.openModal({
              modalType: 'confirm',
              message: 'Do you want to delete this item?',
              onOk: this.handleDelete(id),
            })}
          >
            Delete
          </Menu.Item>
        </Menu>
      }
    >
      <Icon name="ellipsis vertical" />
    </Dropdown>
  );

  handlePageClick = page => {
    LMQCriteriasStore.refetch({ curPage: page });
  };

  render() {
    const { data, loading, sortColumn, sortDirection } = LMQCriteriasStore;
    const column = api.isAdmin() ? columns.map(i => i) : columns.filter(i => i.title !== '').map(i => i);
    const colSpan = column.length;
    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader
          columns={column}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={LMQCriteriasStore.handleSort}
        />
        <TableBody>{this.renderTableBody(data, colSpan)}</TableBody>
        <TableFooterPagination
          colSpan={colSpan}
          currentPage={LMQCriteriasStore.curPage}
          totalPage={LMQCriteriasStore.totalPage}
          totalItems={LMQCriteriasStore.totalItems}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}

export default LMQCriteriasTable;
